module.exports = __webpack_public_path__ + "img/close.88b7a03c.svg";